import { names } from '_/constants/loginPools.constants';
import * as types from '_/types/loginPools';
import dayjs from 'dayjs';
import uniqueId from 'lodash/uniqueId';

const convertToUIItems = (items: { name: string }[], keyPrefix = ''): types.IUIListEditorItem[] =>
  items.map((item) => ({ ...item, key: uniqueId(keyPrefix), exists: true }));

const loginPoolToLoginPoolRowAdapter = (
  loginPool: types.ILoginPool,
  orgSlug: string,
  projectSlug: string,
): types.ILoginPoolRow => {
  const { slug, addedAt } = loginPool;
  const addedAtDayjs = dayjs(addedAt);
  return {
    ...loginPool,
    href: `/orgs/${orgSlug}/projects/${projectSlug}/loginpools/${slug}`,
    addedAt: addedAtDayjs.format('MMM DD, YYYY'),
    addedAtFull: addedAtDayjs.format('MMM DD, YYYY HH:mm:ss'),
  };
};

export const loginPoolsToLoginPoolRowsAdapter = (
  loginPools: types.ILoginPool[],
  orgSlug: string,
  projectSlug: string,
): types.ILoginPoolRow[] => loginPools.map((loginPool) => loginPoolToLoginPoolRowAdapter(loginPool, orgSlug, projectSlug));

export const loginPoolFrontendAdapter = (loginPool: types.ILoginPool): types.IUILoginPool => ({
  ...(loginPool as types.ILoginPoolBase),
  parameters: convertToUIItems(
    loginPool.parameters.map((p) => ({ name: p })),
    `${names.parameters}-`,
  ) as types.IUIParameter[],
  fields: convertToUIItems(loginPool.fields, `${names.fields}-`) as types.IUIField[],
});

export const loginPoolBackendAdapter = (loginPool: types.IUILoginPoolValues): types.ILoginPool =>
  ({
    name: loginPool.name.trim(),
    slug: loginPool.slug.trim(),
    parameters: (loginPool.parameters || []).map((p) => p.name?.trim()).filter((name) => !!name),
    fields: (loginPool.fields || []).map((f) => ({ name: f.name?.trim(), secret: f.secret })).filter((f) => !!f.name),
  }) as types.ILoginPool;

export const loginPoolUpdateBackendAdapter = (loginPool: types.IUILoginPoolValues): Partial<types.ILoginPool> => {
  return {
    name: loginPool.name.trim(),
    fields: (loginPool.fields || [])
      .map((f) => ({ name: f.name?.trim() ?? 'Unnamed', secret: f.secret }))
      .filter((f) => !!f.name),
  };
};
